<template>
  <va-modal
    :value="showModal"
    ref="uploadAdjusttModal"
    :okToClose="false"
    :okDisabled="isSubmitingForm || !form.data.excel"
    :okText="isValidated ? 'Processar Ficheiro' : 'Verificar Ficheiro'"
    :cancelText="$t('modals.buttons.cancel')"
    @ok="submit"
    @cancel="close"
  >

    <div slot="header" class="d-flex flex-column align-items-start">
      <span class="modal-title">Upload Excel Hierarquias Adjustt</span>
    </div>

    <div class="evollu-form mb-3">

      <input id="excel-input" ref="excelInput" type="file" @change="onExcelFileSelected" hidden accept=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
      <div class="d-flex w-100 justify-content-between">
        <h5>
          <b>Ficheiro Excel</b>
        </h5>
        <div>
          <va-popover
            v-if="!form.data.excel"
            placement="left"
            message="Carregar ficheiro Excel">
            <i class="action-icon fa fa-upload pl-2 pr-2" @click.prevent.stop="uploadExcelFile()"></i>
          </va-popover>
        </div>
      </div>
      <div class="d-flex w-100 mb-4 mt-2">
        <div v-if="!form.data.excel" class="d-flex w-100 justify-content-center text-center">
          <span><b>{{$t('reports.reports.labels.no_selected_files')}}</b></span>
        </div>

        <div v-else class="d-flex w-100">
          <div class="d-flex w-100 justify-content-between">
            <span class="filename">{{form.data.excel.name}}</span>
            <span :class="{'pr-5': isSubmitingForm}">{{presentSize(form.data.excel.size)}}</span>
            <va-popover
              v-show="!isSubmitingForm"
              placement="left"
              :message="$t('reports.reports.buttons.delete_upload')">
              <i class="action-icon fa fa-times pl-2 pr-2" @click.prevent.stop="resetExcelUpload()"></i>
            </va-popover>
          </div>
        </div>
      </div>
    </div>

    <div v-if="validationErrors.length > 0">
      <va-card>
        <h6><b>Erros na formatação do Excel:</b></h6>
        <ul>
          <li v-for="(error, index) in validationErrors" :key="index">
            <i class="fa fa-exclamation-triangle" style="color: #c81414;"></i>&nbsp;{{ error }}
          </li>
        </ul>
      </va-card>
      <span class="d-flex justify-content-center text-center">
        <h6><b>Por favor selecione um novo ficheiro.</b></h6>
      </span>
    </div>

    <div v-if="isValidated" class="d-flex flex-column justify-content-center">
      <span class="d-flex justify-content-center text-center">
        <h5><i class="fa fa-check"></i>&nbsp;<b>Formato do ficheiro validado!</b></h5>
      </span>
      <va-card class="w-100 d-flex justify-content-center">
        <span>
          <h6><b>Utilizadores que irão ser criados:</b></h6>
          <ul v-if="validationFeedback.newUsers.length">
            <li v-for="(user, index) in validationFeedback.newUsers" :key="index">{{ `${user.name} (${user.email})` }}</li>
          </ul>
          <span v-else>-----</span>
        </span>
        <span>
          <h6><b>Utilizadores que deixam de pertencer à hierarquia:</b></h6>
          <ul v-if="validationFeedback.deprecatedUsers.length">
            <li v-for="(user, index) in validationFeedback.deprecatedUsers" :key="index">{{ `${user.name} (${user.email})` }}</li>
          </ul>
          <span v-else>-----</span>
        </span>
        <span>
          <h6><b>Entidades que perdem responsáveis Adjustt:</b></h6>
          <ul v-if="validationFeedback.facilitiesThatLostResponsibles.length">
            <li v-for="(facility, index) in validationFeedback.facilitiesThatLostResponsibles" :key="index">{{ `${facility.name} (${facility.facility_code})` }}</li>
          </ul>
          <span v-else>-----</span>
        </span>
      </va-card>
    </div>

    <div class="d-flex flex-column align-items-center justify-content-center mt-3">
      <span v-if="isValidated" class="text-center">
        <h6 v-if="isSubmitingForm">
          <b>A processar ficheiro. Por favor aguarde.</b>
        </h6>
        <h6 v-else>
          <b>Carregue em "Processar Ficheiro" para efetuar as alterações.</b>
        </h6>
      </span>


      <hollow-dots-spinner v-if="isSubmitingForm"
        :animation-duration="1000"
        :size="60"
        color="#29c4a9"
      />
    </div>

  </va-modal>
</template>
<script>
import { HollowDotsSpinner } from 'epic-spinners'
import { GlinttHierarchyService } from '@/api/LeadsService'
import DatePicker from '@/components/common/DatePicker'
export default {
  components: {
    DatePicker,
    HollowDotsSpinner
  },
  data: function () {
    return {
      showModal: false,
      isSubmitingForm: false,
      isValidated: false,
      validationErrors: [],
      validationFeedback: {},
      form: {
        data: {
          excel: undefined,
        },
      }
    }
  },
  mounted () {
    this.showModal = true
  },
  computed: {
    leadsService: function () {
      return this.$store.state.services.find(s => s.url === this.$store.state.evollead_server)
    },
  },
  methods: {
    submit: function () {
      if (!this.isSubmitingform) {
        console.log(this.isSubmitingForm)
        this.isSubmitingForm = true
        this.validationErrors = []

        let formData = new FormData()

        if (this.form.data.excel) {
          formData.append('excel', this.form.data.excel)
        }

        if (!this.isValidated) {
          GlinttHierarchyService.validateFile(formData)
            .then(result => {
              console.log(result)
              this.isValidated = true
              this.validationFeedback = result
            })
            .catch(errors => {
              console.log(errors)
              if (errors.response && errors.response.status) {
                const statusCode = errors.response.status
                switch (statusCode) {
                  case 422:
                    if (errors.response.data.hasOwnProperty('errors')) {
                      this.validationErrors = errors.response.data.errors
                    }
                    break;
                  default:
                    this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
                    break;
                }
              }
              this.resetExcelUpload()
            })
            .finally(() => {
              this.isSubmitingForm = false
            })
        } else {
          GlinttHierarchyService.importFile(formData)
            .then(result => {
              console.log(result)
              this.showToast('Hierarquias Adjustt atualizadas com sucesso!', this.$store.state.successToastOptions)
              this.$refs.uploadAdjusttModal.cancel()
            })
            .catch(errors => {
              this.isValidated = false
              console.log(errors)
              if (errors.response && errors.response.status) {
                const statusCode = errors.response.status
                switch (statusCode) {
                  case 422:
                    if (errors.response.data.hasOwnProperty('errors')) {
                      this.validationErrors = errors.response.data.errors
                    }
                    break;
                  default:
                    this.showToast(this.$t('reports.reports.messages.something_went_wrong'), this.$store.state.errorToastOptions)
                    break;
                }
              }
              this.resetExcelUpload()
            })
            .finally(() => {
              this.isSubmitingForm = false
            })
        }
      }
    },
    close: function () {
      setTimeout(() => {
        this.$emit('modalWasClosed')
      }, 500)
    },
    uploadExcelFile: function () {
      this.$refs.excelInput.click()
    },
    onExcelFileSelected: function (event) {
      this.form.data.excel = event.target.files[0]
      this.validationErrors = []
      this.validationFeedback = []
    },
    resetExcelUpload: function () {
      this.form.data.excel = undefined
      this.$refs.excelInput.value = null
      this.isValidated = false
    },
    presentSize: function (bytes) {
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      if (bytes === 0) return '0 Byte'
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
      return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i]
    }
  }
}
</script>
<style scoped lang="scss">
.filename {
  width: 60%;
}

.action-icon {
  cursor: pointer;
}

</style>
